import Vue from 'vue'
import Vuex, { StoreOptions, Store } from 'vuex'

import { priceSettings } from './modules/price-settings'

Vue.use(Vuex)

const storeOptions: StoreOptions<RootStatePriceSettings> = {
  modules: {
    priceSettings: priceSettings
  }
}

const store: Store<RootStatePriceSettings> = new Vuex.Store(storeOptions)

export default store;
